import { Job } from 'generated/apolloComponents'
import useTranslation from 'next-translate/useTranslation'
import React from 'react'
import { ClipboardDocumentCheckIcon } from '@heroicons/react/24/solid'
import JobListItemWrapper from '@/components/molecules/JobListItem/JobListItemWrapper'
import { LocationIcon } from '../atoms/JobBoardIcons/JobBoardIcons'
import JobListIcons from '../molecules/JobListIcons'

interface IProps {
  recommendations: Job[]
  job: Job
}

const ApplicationSuccess = ({ recommendations, job }: IProps) => {
  const { t, lang } = useTranslation()

  return (
    <main>
      <div className='container mt-14'>
        <div className='flex justify-center'>
          <ClipboardDocumentCheckIcon width={70} className='text-success' />
          <div className='pl-14'>
            <h3
              className=' text-3xl mb-6'
              dangerouslySetInnerHTML={{
                __html: job.internalApplication
                  ? t('common:apply_success')
                  : t('common:apply_success_external'),
              }}
            />
            <div className='font-normal'>
              <p className='mb-5'>{t('common:applied_for_offer')}</p>
              <p className='mb-1'>{job.company.name}</p>
              <p className='font-medium mb-1'>{job.position}</p>
              {job.locations && (
                <p>
                  {job.locations.map((item, index) => (
                    <span key={index} className='mr-4'>
                      <LocationIcon width={15} height={15} className='mr-2' />
                      {lang === 'pl'
                        ? item.location?.cityPl
                        : item.location?.cityEn}
                    </span>
                  ))}
                </p>
              )}
            </div>
          </div>
        </div>
        <div className='pb-14'>
          <h3 className='mt-7 md:mt-14 mb-4 md:mb-7'>
            {t('common:another_apply')}
          </h3>
          <JobListIcons />
          {recommendations &&
            recommendations?.length > 0 &&
            recommendations.map((job, index) => (
              <JobListItemWrapper key={index} job={job} />
            ))}
        </div>
      </div>
    </main>
  )
}

export default ApplicationSuccess
